module.exports = __webpack_public_path__ + "img/Free Response 12.85aa5fb0.png";